import React, { useState, useEffect, useCallback } from 'react';
import { List, Spin, Empty, message } from 'antd';
import { getActiveBreakdownRequests } from '../utils/apiService';
import BreakdownRequestCard from './BreakdownRequestCard';
import PullToRefresh from './PullToRefresh';

const BreakdownRequestList = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const normalizeRequestsResponse = (data) => {
    if (Array.isArray(data)) return data;
    const candidates = [
      data?.requests,
      data?.breakdownRequests,
      data?.items,
      data?.data,
      data?.result,
      data?.payload
    ];
    for (const arr of candidates) {
      if (Array.isArray(arr)) return arr;
    }
    return [];
  };

  const fetchRequests = useCallback(async () => {
    try {
      setRefreshing(true);
      const data = await getActiveBreakdownRequests();
      const arr = normalizeRequestsResponse(data);
      setRequests(arr);
      if (arr.length === 0) {
        message.info('No active breakdown requests found');
      }
    } catch (error) {
      console.error('Error fetching breakdown requests:', error);
      message.error('Failed to load breakdown requests');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, []);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  const handleRefresh = () => {
    setRefreshing(true);
    return new Promise((resolve) => {
      fetchRequests().then(() => {
        resolve();
        setRefreshing(false);
      });
    });
  };

  return (
    <div className="breakdown-request-list-container">
      <PullToRefresh onRefresh={handleRefresh}>
        {loading ? (
          <div className="loading-container" style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
            <Spin size="large" />
          </div>
        ) : requests.length === 0 ? (
          <Empty description="No active breakdown requests" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <>
            {refreshing && (
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingBottom: '16px' }}>
                <Spin size="large" />
              </div>
            )}
            <List
              dataSource={requests}
              renderItem={(req, index) => (
                <List.Item key={req?.id || req?.breakdownRequestReference || index} style={{ padding: 8 }}>
                  <BreakdownRequestCard request={req} />
                </List.Item>
              )}
            />
          </>
        )}
      </PullToRefresh>
    </div>
  );
};

export default BreakdownRequestList;
